import React from 'react';

const News = ({news}) => {
    return (
        <li key={news.id} className="mr-5">
            <a className="notification-text" href={news.newsLink ? news.newsLink : "#"}>
                {news.titleEn}
            </a>
        </li>
    );
};

export default News;
